<template>
  <div>
    <el-form :inline="true" :model="queryFormModel" class="demo-form-inline" size="small">
      <el-form-item label="名称">
        <el-input v-model="queryFormModel.keyword" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="商户">
        <merchant-selector v-model="queryFormModel.merchantId" @change="merchantQueryChanged"></merchant-selector>
      </el-form-item>
      <el-form-item label="代理">
        <proxy-selector v-model="queryFormModel.proxyId" :merchant-id="queryFormModel.merchantId" :disabled="!queryFormModel.merchantId"></proxy-selector>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryList">查 询</el-button>
      </el-form-item>
    </el-form>

    <el-pagination
      style="margin-bottom: 5px; text-align: right;"
      background
      layout="prev, pager, next"
      :current-page.sync="page"
      :page-size.sync="rows"
      :total="tableTotal"
      @current-change="currentPageChanged">
    </el-pagination>

    <el-table ref="scaleTable" :data="tableData" :height="tableHeight" size="small" border style="width: 100%">
      <el-table-column prop="id" label="ID" width="200"></el-table-column>
      <el-table-column prop="merchantName" label="所属商户" width="200"></el-table-column>
      <el-table-column prop="proxyName" label="所属代理" width="200"></el-table-column>
      <el-table-column prop="code" label="编码" width="80"></el-table-column>
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column prop="type" label="类型" :formatter="scaleTypeFormatter"></el-table-column>
      <el-table-column prop="pluType" label="条码类型" width="100"></el-table-column>
      <el-table-column prop="transMemoFlag" label="传成分和备注" width="120">
        <template slot-scope="scope">
            <el-switch v-model="scope.row.transMemoFlag" active-color="#13ce66" inactive-color="#ff4949" active-value="1" inactive-value="0" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="ip" label="IP" width="130"></el-table-column>
      <el-table-column prop="port" label="端口" width="80"></el-table-column>
      <el-table-column prop="enable" label="启用状态" width="100">
        <template slot-scope="scope">
            <el-switch v-model="scope.row.enable" active-color="#13ce66" inactive-color="#ff4949" active-value="1" inactive-value="0" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showDetailDialog(scope.row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="设备详情" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="ID">{{ entity.id }}</el-descriptions-item>
        <el-descriptions-item label="所属商户">{{ entity.merchantName }}</el-descriptions-item>
        <el-descriptions-item label="所属代理">{{ entity.proxyName }}</el-descriptions-item>
        <el-descriptions-item label="编码">{{ entity.code }}</el-descriptions-item>
        <el-descriptions-item label="名称">{{ entity.name }}</el-descriptions-item>
        <el-descriptions-item label="类型">{{ scaleTypeMap[entity.type] }}</el-descriptions-item>
        <el-descriptions-item label="条码类型">{{ entity.pluType }}</el-descriptions-item>
        <el-descriptions-item label="传成分和备注">{{ entity.transMemoFlag === '1' ? '是' : '否' }}</el-descriptions-item>
        <el-descriptions-item label="IP">{{ entity.ip }}</el-descriptions-item>
        <el-descriptions-item label="端口">{{ entity.port }}</el-descriptions-item>
        <el-descriptions-item label="启用状态">{{ entity.enable === '1' ? '启用' : '禁用' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ entity.createTime }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import httpClient from "../httpClient.js";
import MerchantSelector from './MerchantSelector.vue'
import ProxySelector from './ProxySelector.vue'
export default {
  name: "ScaleList",
  components: {
    MerchantSelector,
    ProxySelector
  },
  data() {
    return {
      page: 1,
      rows: 20,
      tableTotal: 0,
      tableData: [],
      tableHeight: 400,
      queryFormModel: {},
      scaleTypeList: [],
      scaleTypeMap: {},
      dialogVisible: false,
      entity: {}
    };
  },
  methods: {
    queryList() {
      let data = {
        page: this.page,
        rows: this.rows,
        params: this.queryFormModel
      }
      httpClient.post("/api/scale/query", data).then((response) => {
        this.tableTotal = response.data.data.total
        this.tableData = response.data.data.list
      })
    },
    currentPageChanged() {
      this.queryList()
    },
    calcTableHeight() {
      this.$nextTick(() => {
        const tableEl = this.$refs.scaleTable && this.$refs.scaleTable.$el
        const top = tableEl ? tableEl.getBoundingClientRect().top : 200
        this.tableHeight = Math.max(300, window.innerHeight - top - 30)
      })
    },
    queryAllScaleType() {
      httpClient.get("/api/scale/type").then((response) => {
        this.scaleTypeList = response.data.data
        this.scaleTypeList.forEach(item => {
          this.scaleTypeMap[item.code] = item.name
        })
      })
    },
    merchantQueryChanged() {
      // 商户变化时重置代理选择
      this.queryFormModel.proxyId = null
    },
    scaleTypeFormatter(row) {
        return this.scaleTypeMap[row.type]
    },
    showDetailDialog(row) {
      httpClient.get(`/api/scale/${row.id}`).then((response) => {
        this.entity = response.data.data
        this.dialogVisible = true
      })
    },
    handleClose() {
      this.dialogVisible = false
    }
  },
  mounted() {
    this.queryList()
    this.queryAllScaleType()
    this.calcTableHeight()
    window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcTableHeight)
  },
};
</script>
